import React, { ChangeEventHandler } from 'react';
import { lang } from '@lang/interfaces/lang';
import InputComponent from '@ui/components/Input/Input.component';


interface IProps {
    lang: lang;
    coordTxPeriod: number | null;
    coordTxPeriodError: boolean;
    onInputClick: () => void;
    onCoordTxPeriodChange: ChangeEventHandler<HTMLInputElement>;
}

const Component: React.FC<IProps> = ({
    lang,
    coordTxPeriod,
    coordTxPeriodError,
    onInputClick,
    onCoordTxPeriodChange,
}: IProps) => {

    return (
        <>
            <InputComponent
                label="coordinateTransmissionPeriod"
                name="period"
                type="number"
                description="coordTxPeriodTooltip"
                helperText="coordinateTransmissionPeriodHelper"
                errorMessage="coordTxPeriodError"
                lang={lang}
                value={coordTxPeriod}
                numberProps={{
                    min: 0,
                    max: 10,
                }}
                error={coordTxPeriodError}
                onChange={onCoordTxPeriodChange}
                onClick={onInputClick}
                onFocus={onInputClick}
            />

        </>
    );
};

const TrackerSettingsComponent = React.memo(Component);

export default TrackerSettingsComponent;
